import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function InstantLoan() {
    return (
        <div>
            <Seo
                title="Prêt rapide en ligne | Trouvez les meilleures offres | Argent Aujourd’hui"
                description="Comparez les prêts rapide en ligne sur notre site et choisissez l'option idéale pour vos besoins financiers. Accédez aux meilleures offres dès maintenant."
                type="webapp"
                name="Argent Aujourd'hui"
                
                
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt rapide</h1>

                    <p className="header-subtitle">
                        Vous vous demandez comment obtenir un prêt très rapidement? Argent
                        Aujourd’hui compare pour vous les solutions de financement les plus
                        avantageuses pour obtenir un prêt d’argent rapide au Québec. Recevez entre
                        100$ à 1500$ en moins de 24 heures grâce à nos partenaires de confiance.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="Situation-steps">
                <div className="content" data-aos="fade-up">
                    <h2 className="sect-title">
                        3 étapes pour obtenir un prêt rapidement en ligne
                    </h2>

                    <p className="sect-subtitle">
                        Face à une urgence ou à des dépenses imprévues, un prêt instantané peut vous
                        aider à retrouver votre sérénité et à mieux gérer vos finances. Vous vous
                        demandez quel est le prêt le plus facile à obtenir? Nous comparons pour vous
                        les meilleures solutions pour répondre à vos besoins immédiats.
                    </p>

                    <ol style={{ marginTop: 50 }}>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:note" width="40" />
                            </div>
                            <h3>Comparez les offres du marché</h3>
                            <p>
                                Explorez vos options de financement en quelques clics! Remplissez
                                notre <Link to="/new-lead">formulaire de demande en ligne</Link> et
                                accédez à des offres de prêts rapides adaptées à vos besoins. Nous
                                vous indiquons les montants disponibles, les délais et les
                                conditions de remboursement de chaque prêteur.{' '}
                                <b>
                                    Ce service est entièrement confidentiel, gratuit et sans
                                    engagement.
                                </b>
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:home" width="40" />
                            </div>
                            <h3>Choisissez une institution et faites votre demande de prêt</h3>
                            <p>
                                En fonction des conditions de chaque prêteur, choisissez l’option
                                qui correspond le mieux à vos besoins. Cliquez sur le nom de
                                l'institution pour être redirigé automatiquement vers leur
                                formulaire en ligne. Vous devrez fournir une pièce d’identité
                                récente ainsi que quelques renseignements personnels afin qu’ils
                                puissent analyser votre demande. Selon les heures d’ouverture, vous
                                pourriez <b>recevoir une réponse en moins d’une heure.</b>
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:paper-plane" width="40" />
                            </div>
                            <h3>Recevez votre prêt en 24h</h3>
                            <p>
                                Une fois que votre demande est approuvée et que vous avez signé
                                l’entente, le prêteur vous transférera les fonds par{' '}
                                <b>virement Interac en moins de 24 heures</b>. Si vous soumettez
                                votre demande le matin, vous pourriez même recevoir votre prêt le
                                jour même!
                            </p>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Les avantages de nos produits</h2>

                    <p className="sect-subtitle">
                        Pour vous permettre de bénéficier des fonds nécessaires en peu de temps,
                        Argent Aujourd’hui simplifie votre recherche de prêt rapide, en vous
                        connectant aux meilleures offres d’
                        <b>institutions de financement québécoises.</b> Notre processus est
                        entièrement en ligne, gratuit et confidentiel.
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 30 }}>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Prêts sans enquête de crédit</h4>

                            <span style={{ marginTop: 130 }}>
                                Les prêts n’affectent pas votre cote de crédit
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Prêts IBV</h4>

                            <span style={{ marginTop: 130 }}>
                                Une vérification bancaire instantanée (IBV) est utilisée pour
                                évaluer votre capacité de remboursement.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Approbation rapide</h4>

                            <span style={{ marginTop: 130 }}>
                                Recevez des fonds en moins de 24 heures sur votre compte bancaire,
                                sans justificatif ou documentation.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Partenaires de confiance</h4>

                            <span style={{ marginTop: 130 }}>
                                Nous travaillons uniquement avec des prêteurs vérifiés pour vous
                                garantir des services sécurisés et fiables.
                            </span>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Choisissez le montant dont vous avez besoin!</h2>

                    <p className="sect-subtitle">
                        Avec Argent Aujourd’hui, profitez de{' '}
                        <b>prêts personnalisés rapides en ligne</b>, adaptés à votre besoin immédiat
                        :
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 100$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 200$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 300$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 500$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 700$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 000$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 500$</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Des prêts pour différents besoins</h2>

                    <p className="sect-subtitle">
                        Quelles que soient les circonstances, nous comprenons qu’un prêt express
                        peut répondre à un besoin urgent. Vous ne devez pas nous expliquer votre
                        situation, il vous suffit de fournir quelques informations personnelles pour
                        accéder à des solutions adaptées à votre demande. Découvrez nos différentes
                        offres :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 20 }}>
                        <li>Prêt sans emploi</li>
                        <li>Avance de fonds</li>
                        <li>Prêt d'urgence</li>
                        <li>Prêt personnel</li>
                        <li>Prêt sur salaire</li>
                    </ul>
                </div>
            </section>

            <section className="Eligible sect-bg-dark">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Êtes-vous éligible?</h2>
                        </div>
                        <p>
                            Saviez-vous que vous pouvez obtenir un prêt rapide{' '}
                            <b>même en cas de mauvais crédit ou si vous n’êtes pas employé?</b> Pour
                            être éligible, vous devez répondre aux critères suivants :
                        </p>
                        <ul>
                            <li>Avoir au moins 18 ans</li>
                            <li>Résider au Québec</li>
                            <li>Avoir un revenu stable</li>
                            <li>Ne pas avoir d’opposition de paiement</li>
                            <li>
                                Avoir le moins de frais de fonds non suffisants possible (frais NSF)
                            </li>
                        </ul>
                        <p>
                            Vous répondez à toutes ces exigences? Faites une demande de prêt rapide
                            dès aujourd’hui pour connaître vos options!
                        </p>
                        <Link to="/new-lead" className="btn">
                            Demander un prêt
                        </Link>
                    </div>
                </div>
            </section>

            {/* <ClientsBanner /> */}

            <Footer />
        </div>
    )
}
